import apiClient from "./httpClient";
import endpoints from "./endpoints";

export const otaApi = {
  deleteShipment: (id) => apiClient.get(endpoints.ota.shipmentDelete(id)),
  deleteShipments: (ids, config) =>
    apiClient.get(endpoints.ota.shipmentDeleteList(), ids, config),
  deleteFiles: (files, config) => apiClient.post(endpoints.ota.fileDelete(), files, config),
  controlShipment: (id, operation) =>
    apiClient.get(endpoints.ota.shipmentOperation(operation, id)),
};

export default otaApi;
